import { Dish, MenuCategory, Section } from '../apiTypes';
import { defaultAllergens } from './menu';

export const testSectionsUA: (Section & { id: string })[] = [
  {
    id: 'llurixn4',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/sections%2Fllurivgh?alt=media&token=10d0cf40-b1e3-4c14-bad2-1c93c15fbbea',
    name: 'Страви',
    order: 1,
    show: true,
  },
  {
    id: 'lluq47lc',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/sections%2Flluq42bw?alt=media&token=178db766-a1bb-4599-9935-9d58ffac6798',
    name: 'Напої',
    order: 2,
    show: true,
  },
];

export const testCategoriesUA: (MenuCategory & { id: string })[] = [
  {
    id: 'lluq512k',
    description: '',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/categories%2Flluq4z3t?alt=media&token=5d6b6310-52e4-4c91-a6e1-83c03fd84042',
    name: 'Безалкогольні напої',
    order: 1,
    sectionId: 'lluq47lc',
    show: true,
  },
  {
    id: 'llurnps4',
    description: '',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/categories%2Flluvnbi5?alt=media&token=db214a28-9607-4cc8-b4a9-d0c50c7c468c',
    name: 'Закуски',
    order: 1,
    sectionId: 'llurixn4',
    show: true,
  },
  {
    id: 'llurrjwo',
    description: '',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/categories%2Fllurtfcn?alt=media&token=4a121cea-a77a-4ae7-92b1-69bb23183e4d',
    name: 'Салати',
    order: 2,
    sectionId: 'llurixn4',
    show: true,
  },
  {
    id: 'llurrcv2',
    description: '',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/categories%2Flluvn0hn?alt=media&token=5a1d55a7-b52c-4503-958e-63bc7ea03b2d',
    name: 'Основні страви',
    order: 3,
    sectionId: 'llurixn4',
    show: true,
  },
];

export const testDishedUA: (Dish & { id: string })[] = [
  {
    allergens: { ...defaultAllergens },
    categoryId: 'lluq512k',
    components: [],
    description: '',
    id: 'lluqg27b',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/dishes%2Flluq89eh?alt=media&token=aed1d5bf-8857-4f61-8538-76e7f1ebb5d8',
    kitchenId: 'lluqa8g9',
    modifications: [],
    name: 'Вода мінеральна',
    order: 1,
    price: 2500,
    show: true,
    spicy: false,
    time: 0,
    variations: [
      {
        components: [],
        name: 'Газована',
      },
      {
        components: [],
        name: 'Не газована',
      },
    ],
    vegetarian: false,
    volume: '500мл',
    taxInfo: null,
  },
  {
    allergens: { ...defaultAllergens },
    categoryId: 'lluq512k',
    components: [],
    description: '',
    id: 'lluqnzu7',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/dishes%2Flluqnheu?alt=media&token=a8c76df9-2f55-44ba-b5de-0e737b9eb966',
    kitchenId: 'lluqa8g9',
    modifications: [],
    name: 'Лимонад полуничний',
    order: 2,
    price: 5500,
    show: true,
    spicy: false,
    time: 0,
    variations: [],
    vegetarian: true,
    volume: '300мл',
    taxInfo: null,
  },
  {
    allergens: { ...defaultAllergens },
    categoryId: 'lluq512k',
    components: [],
    description: '',
    id: 'llurdmqo',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/dishes%2Fllurczng?alt=media&token=57024e5e-55b4-440a-9085-04a48071fdd6',
    kitchenId: 'lluqa8g9',
    modifications: [],
    name: 'Американо',
    order: 3,
    price: 5000,
    show: true,
    spicy: false,
    time: 0,
    variations: [],
    vegetarian: false,
    volume: '',
    taxInfo: null,
  },
  {
    allergens: { ...defaultAllergens },
    categoryId: 'llurnps4',
    components: [],
    description: 'Прошутто, хамон, фует, оливки.',
    id: 'llut2v84',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/dishes%2Fllut2otq?alt=media&token=e451858d-1f40-4a69-803c-d99f5d5c5031',
    kitchenId: 'lluru7ef',
    modifications: [],
    name: 'Мʼясна тарілка',
    order: 1,
    price: 26500,
    show: true,
    spicy: false,
    time: '10',
    variations: [],
    vegetarian: false,
    volume: '250г',
    taxInfo: null,
  },
  {
    allergens: { ...defaultAllergens },
    categoryId: 'llurnps4',
    components: [],
    description: 'Моцарелла, чедер, камембер, мед, горіхи.',
    id: 'llut6bf9',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/dishes%2Fllut64iy?alt=media&token=a2b653ed-13da-4929-97fd-d1f8bffae8cd',
    kitchenId: 'lluru7ef',
    modifications: [],
    name: 'Сирна тарілка',
    order: 2,
    price: 26800,
    show: true,
    spicy: false,
    time: '10',
    variations: [],
    vegetarian: true,
    volume: '260',
    taxInfo: null,
  },
  {
    allergens: {
      ...defaultAllergens,
      eggs: true,
      gluten: true,
      mustard: true,
    },
    categoryId: 'llurrjwo',
    components: [],
    description: 'Мікс-салат, томати, сир Пармезан, яйце перепелине, хлібні грінки , куряче філе, соус Цезар.',
    id: 'lluvef9b',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/dishes%2Flluvecz0?alt=media&token=f77d90d7-9bd0-4d3b-bb88-4e24be2c982c',
    kitchenId: 'lluru7ef',
    modifications: [],
    name: 'Цезар',
    order: 1,
    price: 19500,
    show: true,
    spicy: false,
    time: 0,
    variations: [],
    vegetarian: false,
    volume: '200',
    taxInfo: null,
  },
  {
    allergens: { ...defaultAllergens },
    categoryId: 'llurrcv2',
    components: [],
    description: 'Подається із запеченою картоплею та овочами',
    id: 'llutqhst',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/dishes%2Fllutskjz?alt=media&token=389c2ba0-428c-4098-a0a4-b54d15a82375',
    kitchenId: 'lluru7ef',
    modifications: [],
    name: 'Стейк із яловичини',
    order: 2,
    price: 24000,
    show: true,
    spicy: false,
    time: '35',
    variations: [
      { components: [], name: 'Rare' },
      { components: [], name: 'Medium rare' },
      { components: [], name: 'Medium' },
      { components: [], name: 'Medim well' },
      { components: [], name: 'Well done' },
    ],
    vegetarian: false,
    volume: '200/100/100г',
    taxInfo: null,
  },
  {
    allergens: { ...defaultAllergens },
    categoryId: 'llurrcv2',
    components: [],
    description: '',
    id: 'llutkzpu',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/dishes%2Fllutktcz?alt=media&token=13e00c76-f509-4bee-bce4-54c1ba0720ef',
    kitchenId: 'lluru7ef',
    modifications: [],
    name: 'Філе форелі з овочами',
    order: 1,
    price: 23500,
    show: true,
    spicy: false,
    time: '35',
    variations: [],
    vegetarian: true,
    volume: '200г',
    taxInfo: null,
  },
];
